/**
 * PublishConsentCheckbox — iter238 (Variante B §5)
 *
 * Owner-Vorgabe (PDF §5 · verbindlicher Wortlaut): Vor der Veröffentlichung
 * eines Paid-Media-Beitrags MUSS der Creator diese Checkbox bestätigen.
 * Backend `POST /api/studio/paid-media` liefert 422 wenn `publish_consent`
 * nicht `true` ist.
 */
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

export const PUBLISH_CONSENT_TEXT =
  "Ich habe verstanden, dass bereits heruntergeladene Kopien nicht zurückgerufen werden können.";

export default function PublishConsentCheckbox({ checked, onChange, testId = "publish-consent-checkbox" }) {
  const { t } = useTranslation();
  return (
    <label
      data-testid={testId}
      className={`flex items-start gap-3 p-3 rounded-2xl border cursor-pointer transition-colors ${
        checked ? "border-[#0A0A0A] bg-[#FAFAFA]" : "border-amber-300 bg-amber-50"
      }`}
    >
      <input
        type="checkbox"
        data-testid={`${testId}-input`}
        checked={!!checked}
        onChange={(e) => onChange?.(e.target.checked)}
        className="mt-0.5 shrink-0"
      />
      <div className="flex-1 space-y-1">
        <div className="flex items-center gap-2">
          <AlertTriangle size={14} className="text-amber-600" />
          <span className="text-xs font-semibold text-[#0A0A0A]">
            {t("paid_media.publish_consent_title", { defaultValue: "Bestätigung Veröffentlichung" })}
          </span>
        </div>
        <p className="text-[11px] leading-snug text-[#666]">
          {t("paid_media.publish_consent_text", { defaultValue: PUBLISH_CONSENT_TEXT })}
        </p>
      </div>
    </label>
  );
}
